import React from 'react';
import { Search, CreditCard, Printer, CheckCircle } from 'lucide-react';
import './HowItWorks.css';

const HowItWorks = () => {
  const steps = [
    {
      icon: Search,
      number: '01',
      title: 'Choose Your Poster',
      description: 'Browse our curated collection of digital music posters from talented artists worldwide.'
    },
    {
      icon: CreditCard,
      number: '02',
      title: 'Secure Checkout',
      description: 'Complete your purchase through our secure Stripe checkout. Your digital poster is instantly sent to your email.'
    },
    {
      icon: Printer,
      number: '03',
      title: 'Print Locally',
      description: 'Take your high-resolution digital file to your local print shop for professional quality printing.'
    }
  ];

  return (
    <section className="how-it-works">
      <div className="container">
        <div className="section-header">
          <span className="section-subtitle">Simple Process</span>
          <h2 className="section-title">
            How <span className="gradient-text">It Works</span>
          </h2>
          <p className="section-description">
            Get your favorite music artwork in three easy steps
          </p>
        </div>

        <div className="steps-grid">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div key={index} className="step-card">
                <div className="step-number">{step.number}</div>
                <div className="step-icon">
                  <Icon size={32} />
                </div>
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
                {index < steps.length - 1 && (
                  <div className="step-connector">
                    <div className="connector-line"></div>
                    <div className="connector-arrow">→</div>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="cta-section">
          <div className="cta-content">
            <CheckCircle size={48} className="cta-icon" />
            <h3 className="cta-title">It's That Easy!</h3>
            <p className="cta-description">
              Join thousands of music lovers who have transformed their spaces with stunning poster artwork
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;